export default 'en-US';